export default __webpack_public_path__ + "static/media/best-teacher-ever.5c1f626e.webp";